import * as API from '@/services/API';

export default {
  get(id) {
    return API.apiClient.get(`/staff-roles/${id}`);
  },
  list(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/staff-roles/${query}`);
  },
  async delete(id) {
    return API.apiClient.delete(`/staff-roles/${id}`);
  },
  paginate(link) {
    return API.apiClient.get(link);
  },
  async save(id, data) {
    if (id == 0) {
      return API.apiClient.post(`/staff-roles`, data);
    } else {
      return API.apiClient.put(`/staff-roles/${id}`, data);
    }
  },
  search(options) {
    const query = API.apiHelper.getQueryStringFromObject(options);
    return API.apiClient.get(`/staff-roles/search${query}`);
  }
};
